export default __webpack_public_path__ + "static/media/healthvit.e505e970.jpg";